import React, { useState, useEffect } from 'react'
import { CImage, CButton, CFormLabel } from 'compat/coreui';
import { postData, getData } from '../../helpers/api';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector, connect, useDispatch } from 'react-redux';
import axios from 'axios';

export default function Edit({ user }) {
  // const [businessName, setBusinessName] = useState("")
  // const [, set] = useState("")
  // const [, set] = useState("")
  const dispatch = useDispatch()

  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPincode] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [about, setAbout] = useState("");
  const [phone, setPhone] = useState("");
  const [userData, setUserData] = useState({})
  // const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [showHours, setShowHours] = useState(false);
  const [businessType, setBusinessType] = useState("");
  const [webUrl, setWebUrl] = useState("Not set");
  const [address, setAddress] = useState("");
  const [address2, setAddress2] = useState("");
  const [operationTime, setOperationTime] = useState("");
  const [fax, setFax] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [alternatePhone, setAlternatePhone] = useState("");
  const [alternateEmail, setAlternateEmail] = useState("");
  const [recreational, setRecreational] = useState(false);
  const [creditCard, setCreditCard] = useState(false);
  const [terminalDiscount, setTerminalDiscount] = useState(false);
  const [varientDiscount, setVeteranDiscount] = useState(false);
  const [deliveryHours, setDeliveryHours] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [profileImg, setProfileImage] = useState("");
  const [coverImg, setCoverImage] = useState("");

  useEffect(async () => {
    getUser()
  }, [])

  const setProfilePic = (selectedImg) => {
    console.log("profile image =>>>");
    const selectedFile = selectedImg.files[0];
    setProfileImage(URL.createObjectURL(selectedFile))
    setSelectedFile(selectedFile)
    submitProfileImg()
  }

  const getUser = () => {
    getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
      if (res.data.status) {
        setAddress(res.data.user.address1)
        setAddress2(res.data.user.address2)
        setBusinessName(res.data.user.businessName ? res.data.user.businessName : "Not a seller")
        setBusinessEmail(res.data.user.businessEmail ? res.data.user.businessEmail : "Not a sellet")
        setBusinessType(res.data.user.businessType ? res.data.user.businessType : "Not a seller")
        setCity(res.data.user.city)
        setState(res.data.user.state)
        setPhone(res.data.user.ownerPhone ? res.data.user.ownerPhone : "0000000000")
        setPincode(res.data.user.pincode)
        setAbout(res.data.user.about)
        setFirstName(res.data.user.manager.firstName)
        setLastName(res.data.user.manager.lastName)
        setAlternatePhone(res.data.user.manager.alternatePhone)
        setAlternateEmail(res.data.user.manager.alternateEmail)
        setWebUrl(res.data.user.website)
      }
    }).catch(console.log)
  }

  const submitProfileImg = (e) => {
    if (e)
      e.preventDefault();
    let url = `${process.env.REACT_APP_APP_API_URL}/api/profilepic`
    let formData = new FormData();
    formData.append("photos", selectedFile);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
    return axios.post(url, formData, config).then(response => {
      if (response.status === 200) {
        toast.success("Image uploaded Successful!");
        // dispatch(reset('sellerForm'));
        // history('/profile')
      }
    }).catch(e => {
      if (e && e.response && e.response.data.message) {
        toast.error(e.response.data.message);
      }
    })
  }

  const editProfile = (e) => {
    e.preventDefault();
    const data = {
      "businessName": businessName,
      "businessEmail": businessEmail,
      "phone": phone,
      "webUrl": webUrl,
      "businessType": businessType,
      "address": address,
      "address2": address2,
      "city": city,
      "state": state,
      // "operationTime": "All",
      "pincode": pincode,
      "about": about,
      // "fax": fax,
      // "manager": ,
      // "recreational": recreational,
      // "ageLimit": "",
      // "creditCard": true,
      // "varientDiscount": true,
      // "terminalDiscount": false,
      // "fbUrl": "",
      // "twitterUrl": "",
      // "instaUrl":"" ,
      // "pintrestUrl": "",
      // "googleUrl": "",
      // "onlineOrder": "",
      // "taxRate":"",
      // "deliveryMinimum":"",
      // "deliveryHours":"",
      // "allowGuests": false,
      // "withoutIdOrder": false,
      // "phoneVerify": true,
      // "about":"about testing",
      // "note":"note testing",
      // hours_of_operation: hoursOperationTime,
      // manager:{
      //   firstName:firstName,
      //   lastName: lastName,
      //   alternateEmail:alternateEmail,
      //   alternatePhone:alternatePhone,
      // }
    }
    postData(`${process.env.REACT_APP_APP_API_URL}/api/editprofile`, data).then(res => {
      if (res.data.status) {
        toast.success('Profile edited successfully')
      }
    }).catch(console.log)
  }
  const submitCoverImg = (e) => {
    // e.preventDefault();
    let url = `${process.env.REACT_APP_APP_API_URL}/api/coverimg`
    let formData = new FormData();
    formData.append("photos", selectedFile);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    }
    return axios.post(url, formData, config).then(response => {
        if (response.status === 200) {
            toast.success("Image uploaded Successful!");
            // dispatch(reset('sellerForm'));
            // history('/profile')
        }
    }).catch(e => {
        if (e && e.response && e.response.data.message) {
            toast.error(e.response.data.message);
        }
    })
}
  const setCoverPic = (coverImg) => {
    const selectedFile = coverImg.files[0];
    setCoverImage(URL.createObjectURL(coverImg.files[0]))
    setSelectedFile(selectedFile)
    submitCoverImg()
  }
  return (
    <>
      <ul className="c_8 timeline">
        <li id="new_post">
          <div className="box add">
            <span className="title">Edit your profile</span>
            <div className="textarea_wrap">
              <form className="form-container" >
                <div className="form-group">
                  <div className="col-md-6">
                    <CFormLabel>Upload cover image</CFormLabel>
                    <div className="fileUpload btn btn-primary">
                      <span>Upload</span>
                      <input type="file" className="upload" name="photos" onChange={(e) => setCoverPic(e.target)} />
                    </div>
                    <img style={{ maxWidth: "60%", maxHeight: "200px" }} id="cover" name="photos" src={coverImg} />
                  </div>
                  <div className="col-md-6">
                    <CFormLabel>Upload profile image</CFormLabel>
                    <div className="fileUpload btn btn-primary">
                      <span>Upload</span>
                      <input type="file" className="upload" name="photos" onChange={(e) => setProfilePic(e.target)} />
                    </div>
                    <img style={{ maxWidth: "60%", maxHeight: "200px" }} id="target" src={profileImg} />

                  </div>
                </div>
                <div className="form-group">
                  <div className="col-md-6">
                    <label htmlFor="about">About</label>
                    <input name="about" type="text" className="form-control" placeholder="about" value={about}
                      onChange={(e) => setAbout(e.target.value)} />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="businessEmail">Business Name</label>
                    <input name="businessName" type="text" className="form-control" placeholder="name" value={businessName}
                      onChange={(e) => setBusinessName(e.target.value)} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="col-md-6">
                    <label htmlFor="Business address">Business Email</label>
                    <input type="email" className="form-control" name="businessAddress" value={businessEmail}
                      onChange={(e) => setBusinessEmail(e.target.value)} />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="city">City</label>
                    <input type="text" className="form-control" name="city" placeholder="city" value={city}
                      onChange={(e) => setCity(e.target.value)} />
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-6">
                    <label htmlFor="phone">State</label>
                    <input type="text" className="form-control" name="state" placeholder="State" value={state}
                      onChange={(e) => setState(e.target.value)} />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="zipcode">Zipcode</label>
                    <input type="text" className="form-control" name="zipcode" placeholder="Zipcode" value={pincode}
                      onChange={(e) => setPincode(e.target.value)} />
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-lg-12">
                    <CButton color="success" type="submit" onClick={editProfile}>Submit</CButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </li>
      </ul>
    </>
  )
}